<template>
	<v-container class="treatment-detail" tag="section" fluid constrain>
		<v-sheet :class="[$vuetify.breakpoint.mdAndUp ? 'pa-12' : 'pa-6']">
			<v-row no-gutters>
				<router-link :to="`/behandlinger`" v-if="$vuetify.breakpoint.xsOnly" style="text-decoration:none">
					<v-icon class="pb-1">arrow_back</v-icon>
					<span>vis alle behandlingene</span>
				</router-link>
			</v-row>
			<v-row no-gutters>
				<v-col cols="12" md="5" :pr-12="$vuetify.breakpoint.mdAndUp" class="pt-3" te>
					<v-skeleton-loader v-if="loading && $vuetify.breakpoint.smAndUp" type="image" :width="$vuetify.breakpoint.mdAndUp ? 250 : 150" :style="{ 'margin-left': offset }"> </v-skeleton-loader>
					<icon-title
						:src="getImage(treatment)"
						:width="$vuetify.breakpoint.mdAndUp ? 250 : 150"
						:size="$vuetify.breakpoint.mdAndUp ? '3rem' : '2rem'"
						:iconVisible="$vuetify.breakpoint.smAndUp"
						:offset="false"
						v-if="!loading"
						>{{ treatment.Name }}</icon-title
					>

					<p :class="[$vuetify.breakpoint.mdAndUp && 'pr-12']">
						<!-- {{ treatment.Description }} -->
						Bestill time hos en anbefalt salong på <router-link to="/">Fixit.no</router-link>. Sjekk priser og les kundeomtaler før du bestemmer deg. Rask og enkel timebestilling
					</p>
					<h3 v-if="showSubTreatment">Behandlinger</h3>
					<v-row no-gutters v-if="showSubTreatment" class="mb-5">
						<v-col cols="12" v-for="subTreatment in treatment.Children" :key="subTreatment.Id" class="subtitle-1" :class="[subTreatment.ShouldBeDisplayedAsLandingPage && 'py-2']">
							<a :href="`/behandlinger/${subTreatment.Url}`" v-if="subTreatment.ShouldBeDisplayedAsLandingPage" class="primary--text">{{ subTreatment.Name }}</a>
						</v-col>
					</v-row>
				</v-col>
				<transition name="scroll-y-transition" mode="out-in">
					<v-col cols="12" md="7" class="primary--text headline font-weight-bold">
						<v-row no-gutters>
							<v-col cols="6" sm="6" md="4" v-for="area in areas" :key="area.Url" class="subtitle-1 py-2">
								<router-link :to="`/${treatment.Url}/${area.Url}`">
								{{ area.Title }}
								</router-link>
							</v-col>
						</v-row>
					</v-col>
				</transition>
			</v-row>
		</v-sheet>
	</v-container>
</template>

<script>
import IconTitle from '@/components/IconTitle';
import { TreatmentService } from '@/services';
export default {
	name: 'treatment-details',
	components: {
		IconTitle
	},
	data() {
		return {
			treatment: {},
			areas: [],
			icon: require('@/assets/img/scissor-icon.png'),
			loading: true
		};
	},
	methods: {
		async getData(url) {
			this.loading = true;
			this.areas = await TreatmentService.GetAreasByTreatmentUrl(url);
			this.treatment = await TreatmentService.GetTreatment(url);
			this.loading = false;
		},
		getImage(treatment) {
			if (treatment.Image && treatment.Image.ImageCrops[5]) {
				return treatment.Image.ImageCrops[5].CropUrl;
			} else {
				return this.icon;
			}
		}
	},

	computed: {
		offset() {
			return parseInt(this.width) ? `-${parseInt(this.width) / 200}em` : '-0.75em';
		},
		showSubTreatment() {
			if (Object.keys(this.treatment).length == 0) {
				return 0;
			}
			let show = this.treatment.Children.filter(function(t) {
				return t.ShouldBeDisplayedAsLandingPage;
			});
			return show.length;
		}
	},
	created() {
		const url = this.$route.params.url;
		this.getData(url);
	}
};
</script>

<style lang="scss">
.treatment-detail .v-skeleton-loader__image {
	left: 0;
	height: 250px;

	@media #{map-get($display-breakpoints, 'sm-and-down')} {
		height: 150px;
	}
}
</style>
